<template>
  <div class="table-setting-menus">
    <!-- icons -->
    <a-tooltip placement="bottom">
      <template v-slot:title>
        <span>{{$t("User_Add10")}}</span>
      </template>
      <FormOutlined
        class="setting-menu-icon"
        @click="() => toggleModal('editVisible')"
      />
    </a-tooltip>
    <a-tooltip v-if="record.isEnable === 1" placement="bottom">
      <template v-slot:title>
        <span>{{$t("User_Del1")}}</span>
      </template>
      <CloseCircleOutlined
        class="setting-menu-icon"
        @click="() => toggleModal('deleteVisible')"
      />
    </a-tooltip>

    <!-- modals -->
    <UserAddEditModal
      v-if="editVisible"
      mode="edit"
      :visible="editVisible"
      :toggleModal="() => toggleModal('editVisible')"
      :userInfo="record"
    />
    <UserDeleteModal
      v-if="deleteVisible"
      mode="delete"
      :visible="deleteVisible"
      :toggleModal="() => toggleModal('deleteVisible')"
      :userInfo="record"
    />
  </div>
</template>

<script>
import { computed, reactive, ref, toRefs } from "vue";
import { FormOutlined, CloseCircleOutlined } from "@ant-design/icons-vue";
import UserAddEditModal from "@/components/sideComponents/UserAddEditModal";
import UserDeleteModal from "@/components/sideComponents/UserDeleteModal";

export default {
  name: "UserSettingMenu",
  props: {
    record: Object,
  },
  components: {
    FormOutlined,
    CloseCircleOutlined,
    UserAddEditModal,
    UserDeleteModal,
  },
  setup(props) {
    const state = reactive({
      editVisible: false,
      deleteVisible: false,
    });

    const toggleModal = (name) => {
      state[name] = !state[name];
    };

    return {
      ...toRefs(state),
      toggleModal,
    };
  },
};
</script>